// extracted by mini-css-extract-plugin
export default {"qrcode-container":"BenefitQRCode_qrcode-container__Z3yAt","code":"BenefitQRCode_code__JZ9sN","qrcode":"BenefitQRCode_qrcode__zVSGo","url":"BenefitQRCode_url__LVGBD"};